<script>
import CoordinatorIndexView from "@/components/coordinator/CoordinatorIndexView";
export default CoordinatorIndexView
</script>